import React, {useEffect, useState} from 'react';

import { Box, Stack, styled, Tab, Tabs, tabsClasses, Typography } from '@mui/material';
import ModalComponent from 'src/components/Modal/ModalComponent';
import FormSearchCompanyTrade from 'src/features/TradeData/Common/FormSearchCompanyTrade';
import FormSearchGlobalTrade from 'src/features/TradeData/Common/FormSearchGlobalTrade';
import { TABS_TRADE_SEARCH_FORMS, TypeTabTradeSearchForms } from 'src/features/TradeData/config';
import colorSystem from 'src/scss/_colors-system.module.scss';
import { useLocation } from "react-router-dom";
import {AuthRouteKeys} from "src/utils/constants/routes";

interface IProps {
  open: boolean;
  handleClose: () => void;
}

const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 20,
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  borderRadius: theme.shape.borderRadius * 2,
  color: colorSystem.neutroState400,
  paddingTop: theme.spacing(1.12),
  paddingBottom: theme.spacing(1.12),

  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(5),
  '&.MuiTab-root:hover': {
    color: theme.palette.text.secondary,
  },
  '&.Mui-selected': {
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&.Mui-selected:hover': {
    color: theme.palette.common.white,
  },
  '&.MuiTab-root': {
    textTransform: 'uppercase',
  },
}));

const StyledTabs = styled(Tabs)(({ theme }) => ({
  [`& .${tabsClasses.scrollButtons}`]: {
    '&.Mui-disabled': { opacity: 0.3 },
  },
  [`& .${tabsClasses.flexContainer}`]: {
    border: 'none',
  },
  width: 'fit-content',
  borderRadius: theme.spacing(1),
  background: colorSystem.backgroundPaper2,
  border: `1px solid ${colorSystem.neutroState300}`,
  padding: theme.spacing(0.8),
}));

const TabComponent = ({
  selected,
  handleChange,
  tabs,
}: {
  selected: string;
  handleChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabs: ITabSetting[];
}) => {
  return (
    <StyledTabs
      TabIndicatorProps={{
        style: { display: 'none' },
      }}
      value={selected}
      onChange={(event: React.SyntheticEvent, newValue: string) => {
        handleChange(event, newValue);
        // setSearchParam({ tab: newValue });
      }}
      variant="scrollable"
    >
      {tabs.map((tab: ITabSetting) => {
        const Icon = tab.icon;
        return <StyledTab value={tab.key} disabled={tab.disable} key={tab.key} label={tab.label}></StyledTab>;
      })}
    </StyledTabs>
  );
};

const FormSearchTradeData: React.FC<IProps> = ({ open, handleClose }) => {
  const location = useLocation();

  const pathname = location.pathname;
  const defaultTab = pathname === AuthRouteKeys.CompanyTradeData ? TABS_TRADE_SEARCH_FORMS[1].key : TABS_TRADE_SEARCH_FORMS[0].key;
  const [selectedTab, setSelectedTab] = useState(defaultTab);


  useEffect(() => {
    setSelectedTab(defaultTab);
  }, [defaultTab]) // when location changes, update the selected tab
  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <Stack flexDirection={'column'} justifyContent={'center'} alignItems={'center'} gap={1}>
        <TabComponent
          tabs={TABS_TRADE_SEARCH_FORMS}
          selected={selectedTab}
          handleChange={(_, value) => {
            setSelectedTab(value);
          }}
        />
        <Typography textAlign={'center'} variant="h5">
          Import/Export Data
        </Typography>
        <Box>
          {selectedTab === TypeTabTradeSearchForms.GlobalTradeData ? (
            <FormSearchGlobalTrade handleClose={handleClose} />
          ) : (
            <FormSearchCompanyTrade handleClose={handleClose} />
          )}
        </Box>
      </Stack>
    </ModalComponent>
  );
};

export default FormSearchTradeData;
